// Same people as Administration::ClaimPolicy::ALLOWED_USER_IDS.
// Importing claims is only user 1, matching ClaimImportPolicy.
// MoneyWorks calls are refused off the office network. The claims screens stay available.
import { Store } from "modules/0_web/1_entry";

export const CLAIM_USER_IDS = [1, 2, 77, 44];
export const CLAIM_IMPORT_USER_IDS = [1];

export const canUseClaims = () => {
  const user = Store.getState()?.current_user;
  return CLAIM_USER_IDS.includes(Number(user?.id));
};

export const canImportClaims = () => {
  const user = Store.getState()?.current_user;
  return CLAIM_IMPORT_USER_IDS.includes(Number(user?.id));
};
